import { render, staticRenderFns } from "./PerformanceRealizeDetail.vue?vue&type=template&id=704eebde&"
import script from "./PerformanceRealizeDetail.vue?vue&type=script&lang=js&"
export * from "./PerformanceRealizeDetail.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceRealizeDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VNavigationDrawer,VSimpleTable})
